export default "__VITE_PUBLIC_ASSET__21ed30bd__"